module.exports = __webpack_public_path__ + "static/media/sesame_icon.37ac31bc.png";